import React from 'react';
import ReadOnlyTable from '../../../Component/DataGrids/AGGrid/ReadOnlyTable';
import "../Admin.css";
import useFetch from '../../../useHook/useFetch';
import { Button, } from "@mui/material";
import DownloadCSV from "../../../ServerCalls/DownloadCSV";

const UserAccount = ({ param }) => {
    return (
        <UserPanel />
    );
}

const UserPanel = () => {
    const { data, loading, error } = useFetch("/getMonitoringDetails");

    const downloadCallerObj = DownloadCSV();
    const handleDownloadClick = () => {
        downloadCallerObj.caller("/downloadUserHistory");
    };


    let processedData = [];
    let headers = [];
    if (data) {

        if (Array.isArray(data.data)) {
            processedData = [...data.data].map(item => ({
                ...item,
                TotalSavedFiles: Number(item.TotalSavedFiles)
            })).sort((a, b) => b.TotalSavedFiles - a.TotalSavedFiles);
        }


        if (data.headers) {
            headers = data.headers;
        } else {
            console.error("Headers not defined in the fetched data");
        }
    }


    return (
        <>
            <Button variant='contained' color='success' onClick={handleDownloadClick}>
                Download CSV
            </Button>
            <ReadOnlyTable
                TableData={{ data: processedData, headers }}
            />
        </>
    );
}

export default UserAccount;
